// @flow

// State Configuration
export const TREE = 'seasonData'
export const BRANCH = 'seasons'
